import styled from 'styled-components';

export const DeferredPaymentsMessageContainer = styled.div`
  background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  padding: 12px 16px 12px 80px;
  border-radius: 8px;
  position: relative;

  img {
    position: absolute;
    left: 16px;
    top: 16px;
  }
`;

export const Description = styled.div`
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  margin-bottom: 8px;
`;

export const Link = styled.a`
  display: block;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  margin-top: 12px;
  text-decoration: underline;
`;

export const DescriptionFilter = styled(Description)`
  margin-bottom: 0;
`;
